export type RequestFeedbackEvent = {
  type: 'permission-denied';
};

type RequestFeedbackListener = (event: RequestFeedbackEvent) => void;

const listeners = new Set<RequestFeedbackListener>();

export function publishRequestFeedback(event: RequestFeedbackEvent): void {
  for (const listener of listeners) {
    listener(event);
  }
}

export function publishPermissionDenied(): void {
  publishRequestFeedback({ type: 'permission-denied' });
}

export function subscribeToRequestFeedback(
  listener: RequestFeedbackListener
): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
